import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';

export const OnboardingDialog = ({ title, testId, children }) => <Dialog open modal>
  <DialogContent hideClose overlayClassName="z-[10040]" className="z-[10050] max-w-xl max-h-[calc(100dvh-2rem)] overflow-y-auto bg-[var(--ps-bg-surface)] text-[var(--ps-text-primary)] border-[var(--ps-border)]" data-testid={testId}
    onInteractOutside={event => event.preventDefault()} onEscapeKeyDown={event => event.preventDefault()}>
    <DialogTitle className="sr-only">{title}</DialogTitle>
    <DialogDescription className="sr-only">Your Par Seeker account setup</DialogDescription>
    {children}
  </DialogContent>
</Dialog>;